import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { forkJoin, of, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { CatEmployeeJobModel } from 'src/app/model/cat-employee-job.model';
import { ComProductSharedModel } from 'src/app/model/com-product-shared.model';
import { HMGenericCatalog } from 'src/app/model/hypermatrix-catalogs-models';
import { CatalogModel } from 'src/app/model/other-catalogs-models';
import { CatEmployeeJobService } from 'src/app/services/cat-employee-job.service';
import { ComProductSharedService } from 'src/oldApp/services/com-product-shared.service';
import { HypermatrixCatalogsService } from 'src/app/services/hypermatrix-catalogs.service';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { isNullOrUndefined } from 'util';


@Component({
  selector: 'app-modal-sc-product-shared',
  templateUrl: './modal-sc-product-shared.component.html',
  styleUrls: ['./modal-sc-product-shared.component.css']
})
export class ModalScProductSharedComponent implements OnInit {
  @Input() product:ComProductSharedModel;
  @Input() page:string;
  @Input() mode:string;

  // estado pagina
  public viewStatus:number=0;
  public formIsLocked:boolean=false;

  // catalogos
  public employeeJobCatalog:CatalogModel[]=[];
  public productCOECatalog:HMGenericCatalog[]=[];
  public groupCollectCatalog:any=[
    {id:1, description:'grupo 1'},
    {id:2, description:'grupo 2'}
  ];

  // mascaras
  public customPatterns={
    'A':{pattern:new RegExp('[a-zA-Z0-9ñÑ ]')},                     // inputs regulares
    'C':{pattern:new RegExp('[a-zA-Z0-9áéíóúÁÉÍÓÚüÜñÑ,._:%\/() \-]')},       // comentarios (acepta acentos, comas y puntos)
    'N':{pattern:new RegExp('[0-9]')} 
  };

  /////////////////
  constructor(
    private comProductSharedService:ComProductSharedService,
    private employeeJobService:CatEmployeeJobService,
    private hypermatrixCatalogsService:HypermatrixCatalogsService,
    private modalService: NgbModal,
    private toastr:ToastrService,
    private utils:UtilitiesService
  ) { }
  ngOnInit() {
    this.getCatalogs();
  }

  updateEmployeeJob=()=> {}
  updateProductCOE=()=> {}
  updateGroupCollect=()=> {}
  updateMinCollect=(e)=> { 
    this.product.minCollect = isNullOrUndefined(e) || e==='' ? null : Number(e);
  }
  updateMaxCollect=e=> this.product.maxCollect=Number(e);
  updateCommission=e=> this.product.commission=Number(e);
  toggleActive=()=> this.product.activeId=!this.product.activeId;
  isValid=()=> {
    let valid=true;
    let errors=[];
    if(this.employeeJobError()) errors.push('Necesita seleccionar un puesto.');
    if(this.productCOEError()) errors.push('Necesita seleccionar un producto.');
    if(this.minCollectError()) errors.push('Necesita capturar un cobro mínimo.');
    if(this.maxCollectError()) errors.push('Necesita capturar un cobro máximo.');
    if(this.maxMinCollectError()) errors.push('Necesita capturar un cobro máximo mayor al cobro mínimo.');    
    if(this.commissionError()) errors.push('Necesita capturar una comisión.');
    if(errors.length>0) {
      valid=false;
      this.toastr.error(errors.join('<br>'), '¡Atención!', {enableHtml:true});
    }
    return valid;
  }
  save=()=> {
    if(this.isValid()) {
      // mostrar spinner
      this.viewStatus=0;
      // enviar informacion
      this.comProductSharedService.save(this.product)
        .pipe(
          tap((resp:any)=> {
            console.log(resp);
            this.modalService.dismissAll('success');
            this.toastr.success('La categoría se guardó con éxito.');
          }),
          catchError(error=> {
            console.log(error);
            this.modalService.dismissAll('failure');
            return of(this.toastr.error('Ocurrió un error al intentar guardar la categoría.'));
          })
        )
        .subscribe();
    }
  }
  close=()=> this.modalService.dismissAll();

  // HELPERS
  employeeJobError=()=> !this.product.employeeJobId;
  productCOEError=()=> !this.product.productosCOEId;
  groupCollectError=()=> !this.product.groupCollectId;
  minCollectError=()=> isNullOrUndefined(this.product.minCollect);
  maxCollectError=()=> this.product.maxCollect==0 || !this.product.maxCollect;
  maxMinCollectError=()=> this.product.maxCollect<this.product.minCollect;
  commissionError=()=> this.product.commission==0 || !this.product.commission;
 
  // INFO
  getCatalogs=()=> {
    forkJoin(
      this.employeeJobService.catalog(),
      this.hypermatrixCatalogsService.getCatalog('ProductosCOE')
    )
    .pipe(
      tap(([catEmpJobResp, productResp]:[any, any])=> {
        if(catEmpJobResp && productResp) {
          this.employeeJobCatalog=catEmpJobResp.data;
          this.productCOECatalog=productResp.data.sort(this.utils.sortBy('description'));
          this.viewStatus=1;
        }
        else throwError;
      }),
      catchError(error=> {
        console.log(error);
        this.viewStatus=-1;
        return of(this.toastr.error('Ocurrió un error al leer los catálogos.'));
      })
    )
    .subscribe();
  }
}
